import { Bell, SlidersHorizontal } from 'lucide-react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/cn';
import { useIsManager } from '@/access/usePerm';
import { useUnreadCount } from '@/features/notifications/api';
import { Logo } from './Logo';

/**
 * ראש כל מסך עובד: פחם, גובה 64, לוגו בצד ההתחלה (ימין ב RTL), פעולות בצד הסוף.
 * גרסת title מציגה כותרת display-l במקום הלוגו.
 *
 * כניסה לאזור הניהול מוצגת רק למי שיש לו מפתח ניהול. למי שאין, היא לא
 * קיימת: לא כפתור מושבת ולא "אין הרשאה".
 */
export function AppBar({ title, className }: { title?: string; className?: string }) {
  const isManager = useIsManager();
  const unread = useUnreadCount();
  const unreadCount = unread.data ?? 0;

  return (
    <header
      className={cn(
        'sticky top-0 z-20 flex h-16 items-center justify-between gap-3 bg-charcoal px-4 text-on-charcoal',
        className,
      )}
    >
      {title ? (
        <h1 className="m-0 font-display text-display-l font-semibold">{title}</h1>
      ) : (
        <Logo on="charcoal" />
      )}

      <div className="flex items-center">
        {isManager && (
          <Link
            to="/admin"
            aria-label="אזור ניהול"
            title="אזור ניהול"
            className="inline-flex min-h-11 min-w-11 items-center justify-center"
          >
            <SlidersHorizontal size={24} strokeWidth={1.75} aria-hidden="true" />
          </Link>
        )}

        <Link
          to="/notifications"
          aria-label={unreadCount > 0 ? `התראות, ${unreadCount} חדשות` : 'התראות'}
          className="relative inline-flex min-h-11 min-w-11 items-center justify-center"
        >
          <Bell size={24} strokeWidth={1.75} aria-hidden="true" />
          {unreadCount > 0 && (
            <span className="absolute top-1.5 end-1.5 min-w-5 rounded-pill bg-olive px-1 text-label font-medium text-on-olive tabular">
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </Link>
      </div>
    </header>
  );
}
